<template>
  <label class="ux-field-title" v-if="showLabel"
    >{{ label }}
    <span class="ux-required-marker" v-if="required">*</span></label
  >
  <div class="ux-field-description" v-if="showDescription">
    {{ description }}
  </div>
  <div v-if="multiValue">
    <!-- No need for this when it's a keyfield -->
  </div>
  <template v-else>
    <flex-row gap>
      <flex-cell>
        <div class="ux-key-wrap" @click="edit">
          {{ model }} <ux-icon icon="far fa-pen-to-square" />
        </div>
      </flex-cell>
      <!-- <flex-cell shrink vcenter v-if="copyable">
        <ux-button :size="size" tag="a" icon @click="copy">
          <ux-icon icon="fa-copy" />
        </ux-button>
      </flex-cell> -->
    </flex-row>
  </template>
</template>
<script>
import InputMixin from "./input-mixin";
import { reactive } from "vue";

export default {
  props: {
    modelValue: {
      type: [String, Array],
    },
  },
  data() {
    return {};
  },
  mixins: [InputMixin],
  computed: {
    copyable() {
      return this.$sdk.global.copyText && this.field.copyable;
    },
    uneditable() {
      return this.field.editable === false;
    },
  },
  methods: {
    async edit() {
      const self = this;

      const { key } = await self.$sdk.prompt(
        [
          {
            title: "Key",
            type: "string",
            key: "key",
            type: "key",
            minimum: 1,
            maximum: 1,
            defaultValues: [self.model],
            autofocus: true,
          },
        ],
        {
          title: "Set a key",
          description:
            "This is a database key that once set should rarely be changed. Only edit this if you know what you are doing.",
        },
      );

      self.model = key;
    },
    copy(index) {
      let value;
      if (this.maximum === 1) {
        value = this.model;
      } else {
        value = this.model[index];
      }

      this.$sdk.global.copyText(value);
    },
    cleanOutputValue(v) {
      var cleaned = this.cleanTextInput(v, this.type, this);
      return cleaned ? String(cleaned) : "";
    },
    cleanInputValue(v) {
      return this.cleanTextInput(v, this.type, this);
    },
    getNewDefaultEntry() {
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.ux-key-wrap {
  cursor: pointer;
  opacity: 0.5;
  text-decoration: underline;
  font-size: 0.9em;
}
</style>
